/** @format */

import {useCallback} from 'react'

import {useFormspreeContext} from '@src/contexts'

export function useIsFileUploadArray() {
  const {FILE_UPLOADS_BUCKET_URL, S3_URL} = useFormspreeContext()
  const fileUploadsHostname = FILE_UPLOADS_BUCKET_URL ?? S3_URL
  return useCallback(
    (value: unknown): value is string[] => {
      if (!fileUploadsHostname) {
        return false
      }
      function isFileUpload(file: unknown): boolean {
        if (typeof file !== 'string') {
          return false
        }
        try {
          const {hostname} = new URL(file)
          return hostname === fileUploadsHostname
        } catch {
          return false
        }
      }
      return Array.isArray(value) && value.some(isFileUpload)
    },
    [fileUploadsHostname],
  )
}
